import axios from 'axios';

import {
  getHeaders,
} from './Utils';

import {
  ENDPOINT_CATEGORIES,
} from './constants';

export default class Categories {
  static getAll() {
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: ENDPOINT_CATEGORIES,
    }).catch((err) => {
      throw new Error(err);
    });
  }

  static getCategoryById(id) {
    return axios({
      method: 'get',
      headers: getHeaders(),
      url: `${ENDPOINT_CATEGORIES}/${id}`,
    }).catch((err) => {
      throw new Error(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/api/Categories.js